import React, { ReactElement } from 'react'
import Image from 'next/image'
import src from '../../../../../public/splashPage/avatars/andrew.webp'

export const AndrewImage: React.FC<unknown> = (): ReactElement => (
    <Image src={src} alt={'Andrew'} />
)
